module.exports = __webpack_public_path__ + "static/media/Sept22-F18.c8d884b3.png";